import { Component, OnInit } from '@angular/core';
import { Dati } from 'src/app/model/dati';
import { Province } from 'src/app/model/province';
import { Regioni } from 'src/app/model/regioni';
import { DatiService } from 'src/app/shared/dati.service';

@Component({
  selector: 'app-home',
  template: `
  <div *ngIf="!dati">
    <app-spinner></app-spinner>
  </div>
    <div class="container-fluid">
      <div class="row">

        <div class="col-md-3 cont">
          <div class="col-md-12 bg">
            <p>Attuali positivi</p>
            <span *ngFor="let dato of dati; last as last">
              <div class="totalePositivi" *ngIf="last">
                {{dato.totale_positivi | number: '' : 'it-IT'}}
              </div>
            </span>
            <div class="sub">
              <p class="subtitle">Incremento</p>
              <span class="totalePositivi" *ngFor="let dato of dati; last as last; index as i">
                <div *ngIf="last">
                  {{dato.totale_positivi - dati[i - 1].totale_positivi | number: '' : 'it-IT'}}
                  <span style="font-size: 0.5em;color: lightgray">
                     ({{dato.totale_positivi - dati[i - 1].totale_positivi - (dati[i - 1].totale_positivi - dati[i - 2].totale_positivi)}})
                  </span>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-3 cont">
          <div class="col-md-12 bg">
            <p>Dimessi guariti</p>
            <span *ngFor="let dato of dati; last as last">
              <div class="guariti" *ngIf="last">
                {{dato.dimessi_guariti | number: '' : 'it-IT'}}
              </div>
            </span>
            <div class="sub">
              <p class="subtitle">Incremento</p>
              <span class="guariti" *ngFor="let dato of dati; last as last; index as i">
                <div *ngIf="last">
                  {{dato.dimessi_guariti - dati[i - 1].dimessi_guariti | number: '' : 'it-IT'}}
                  <span style="font-size: 0.5em;color: lightgray">
                       ({{dato.dimessi_guariti - dati[i - 1].dimessi_guariti - (dati[i - 1].dimessi_guariti - dati[i - 2].dimessi_guariti)}})
                  </span>
                </div>
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-3 cont">
          <div class="col-md-12 bg">
            <p>Deceduti</p>
            <span *ngFor="let dato of dati; last as last">
              <div class="deceduti" *ngIf="last">
                {{dato.deceduti | number: '' : 'it-IT'}}
              </div>
            </span>
            <div class="sub">
              <p class="subtitle">Incremento</p>
              <span class="deceduti" *ngFor="let dato of dati; last as last; index as i">
                <div *ngIf="last">
                  {{dato.deceduti - dati[i - 1].deceduti | number: '' : 'it-IT'}}
                  <span style="font-size: 0.5em;color: lightgray">
                       ({{dato.deceduti - dati[i - 1].deceduti - (dati[i - 1].deceduti - dati[i - 2].deceduti)}})
                  </span>
                </div>
              </span>
            </div>
          </div> 
        </div>

        <div class="col-md-3 cont">
          <div class="col-md-12 bg">
            <p>Totali casi</p>
            <span *ngFor="let dato of dati; last as last">
              <div class="totaleCasi" *ngIf="last">
                {{dato.totale_casi | number: '' : 'it-IT'}}
              </div>
            </span>
            <div class="sub">
              <p class="subtitle">Incremento</p>
              <span class="totaleCasi" *ngFor="let dato of dati; last as last; index as i">
                <div *ngIf="last">
                  {{dato.totale_casi - dati[i - 1].totale_casi | number: '' : 'it-IT'}}
                  <span style="font-size: 0.5em;color: lightgray">
                    ({{dato.totale_casi - dati[i - 1].totale_casi - (dati[i - 1].totale_casi - dati[i - 2].totale_casi)}})
                </span>
                </div>
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="container-fluid">
      <div class="row">

        <div class="col-md-6">
          <div class="col-md-12 fisso">
            <table class="table table-dark">
              <thead>
                <tr>
                  <th>Regione</th>
                  <th>Casi totali</th>
                  <th>Casi attuali</th>
                  <th>Incremento</th>
                  <th>Ricoverati con sintomi</th>
                  <th>Terapia intensiva</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let reg of regioni | sort: 'desc':'totale_casi'">
                  <td><a [routerLink]="['/regioni/', reg.denominazione_regione]">{{reg.denominazione_regione}}</a></td>
                  <td style="color: red">{{reg.totale_casi | number: '' : 'it-IT'}}</td>
                  <td style="color: rgb(255,170,0)">{{reg.totale_positivi | number: '' : 'it-IT'}}</td>
                  <td style="color: lightgray">{{reg.nuovi_positivi}}</td>
                  <td style="color: rgb(255,170,0)">{{reg.ricoverati_con_sintomi}}</td>  
                  <td style="color: red">{{reg.terapia_intensiva}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
        <div class="col-md-3">
          <div class="col-md-12 fisso">
            <table class="table table-dark">
              <thead>
                <tr>
                  <th>Province</th>
                  <th>Casi totali</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let prov of province | sort: 'desc':'totale_casi'">
                  <td>{{prov.denominazione_provincia}}</td>
                  <td style="color: red">{{prov.totale_casi | number: '' : 'it-IT'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-md-3 cont" style="margin-top: -10px">
            <div class="col-md-12 bg">
                <p style="margin-top: -4px">Tamponi effettuati:
                    <span class="tamponi" *ngFor="let dato of dati;index as i;last as last">
                        <div *ngIf="last">
                            <span style="color:lightgray; font-size: 1em">
                                {{dato.tamponi - dati[i - 1].tamponi | number: '' : 'it-IT'}}
                            </span>
                        </div>
                    </span>
                </p>
                <div class="sub">
                    <p class="subtitolo">Incidenza dei positivi rispetto ai tamponi effettuati</p>
                    <span *ngFor="let dato of dati; index as i; last as last;">
                        <div *ngIf="last">
                            {{(dato.nuovi_positivi / (dato.tamponi - dati[i - 1].tamponi)) * 100 | number:'1.1-1'}} %
                        </div>
                    </span>
                </div>
            </div>
        </div>
        
      </div>
    </div>
    <app-footer></app-footer>
  `,
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  // definisco gli oggetti
  dati: Dati[];
  regioni: Regioni[];
  province: Province[];

  // inietto il service all'interno del costruttore
  constructor(private datiService: DatiService) { }

  // Metodo dati nazionali
  getDati() {
    this.datiService.getDati()
      .subscribe(res => {
        this.dati = res;
        console.log(this.dati);
    })
  }

  // Metodo dati regionali
  getDatiReg() {
    this.datiService.getDatiReg()
      .subscribe(res => {
        this.regioni = res;
        console.log(this.regioni);
    })
  }

  // Metodo dati provinciali
  getDatiProv() {
    this.datiService.getDatiProv()
      .subscribe(res => {
        this.province = res;
        console.log(this.province);
    })
  }

  ngOnInit(): void {
    // inizializzo i metodi nazioni, regioni e province
    this.getDati();
    this.getDatiReg();
    this.getDatiProv();
  }

}
